import { CaptionText, H4Text } from '@prisjakt/ui/text/variants';
import { useAppContext } from '@prisjakt/ui-app-context';
import React from 'react';
import PrisjaktIcon from 'src/components/prisjakt-icon';
import { useTheme } from 'styled-components';
import { IconWrapper, OurChoiceInfoContainer, TitleContainer } from './styles';

type Props = {};

export const OurChoiceInfo: React.FC<Props> = () => {
  const { t } = useAppContext();
  const { colors } = useTheme();

  return (
    <OurChoiceInfoContainer>
      <TitleContainer>
        <IconWrapper>
          <PrisjaktIcon color={colors.positive500} size={22} />
        </IconWrapper>
        <H4Text>{t('product', 'prices.our-choice')}</H4Text>
      </TitleContainer>

      <CaptionText>{t('product', 'prices.our-choice-explanation')}</CaptionText>
    </OurChoiceInfoContainer>
  );
};
